// src/sw-registration.js
import { syncConfig } from './config.js';

// Check if PWA is enabled from generated PWA config
// This file is generated during prebuild from app.json
// Use static import (like other config files)
// pwa-config.js is always generated during prebuild (with default if app.json missing)
// eslint-disable-next-line import/no-unresolved
import pwaConfig from './config/pwa-config.js';

const enablePWA = pwaConfig?.enablePWA ?? true;

function checkPWAEnabled() {
  return enablePWA;
}

// Disable service worker in development mode
const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';

if ('serviceWorker' in navigator && !isDevelopment) {
    let refreshing = false;
    window.addEventListener('load', async () => {
        // Check PWA flag before registering
        const pwaEnabled = checkPWAEnabled();
        if (!pwaEnabled) {
            console.log('PWA is disabled in app.json, skipping service worker registration');
            return;
        }
        try {
            const registration = await navigator.serviceWorker.register('/service-worker.js', {
                scope: '/'
            });
            console.log('Service Worker registered with scope:', registration.scope);
            window.swRegistration = registration;

            // Background Sync
            if (syncConfig.enableSync && syncConfig.enableBackgroundSync && 'sync' in registration) {
                try {
                    await registration.sync.register('sync-data');
                    console.log('Background sync registered');
                } catch (error) {
                    console.info('Background sync not available:', error);
                }


                // Periodic Sync
                if (syncConfig.enablePeriodicSync && 'periodicSync' in registration) {
                    try {
                        const status = await navigator.permissions.query({
                            name: 'periodic-background-sync',
                        });
                        if (status.state === 'granted') {
                            await registration.periodicSync.register('sync-data', {
                                minInterval: 60 * 60 * 1000
                            });
                            console.log('Periodic sync registered');
                        }
                    } catch (error) {
                        console.info('Periodic sync not supported');
                    }
                }
            }
        } catch (error) {
            console.error('Service Worker registration failed:', error);
        }
    });

    // Handle controller updates
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
            refreshing = true;
            window.location.reload();
        }
    });
}